<template>
	<div class="list">
		<div class="list-tt">格局旺衰</div>
		<div class="list-info" style="display: block;">
			<div class="panci" v-html="panci"></div>
			<div class="shen" v-html="shen"></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['geju'],
		data() {
			return {
				infoHtml: '',
				panci: '',
				shen: '',
				wangYue: { // 五行当令月份
					"木": ["寅", "卯"],
					"火": ["巳", "午"],
					"金": ["申", "酉"],
					"水": ["亥", "子"],
					"土": ["辰", "戌", "丑", "未"]
				},
				xiangYue: { // 五行相令月份
					"木": ["亥", "子"],
					"火": ["寅", "卯"],
					"金": ["辰", "戌", "丑", "未"],
					"水": ["申", "酉"],
					"土": ["巳", "午"]
				},
				getWx: {
					'甲': '木',
					'乙': '木',
					'丙': '火',
					'丁': '火',
					'戊': '土',
					'己': '土',
					'庚': '金',
					'辛': '金',
					'壬': '水',
					'癸': '水',
				},
				luRen: {
					甲: {
						lu: "寅",
						ren: "卯"
					},
					乙: {
						lu: "卯",
						ren: "寅"
					},
					丙: {
						lu: "巳",
						ren: "午"
					},
					丁: {
						lu: "午",
						ren: "巳"
					},
					戊: {
						lu: "巳",
						ren: "午"
					},
					己: {
						lu: "午",
						ren: "巳"
					},
					庚: {
						lu: "申",
						ren: "酉"
					},
					辛: {
						lu: "酉",
						ren: "申"
					},
					壬: {
						lu: "亥",
						ren: "子"
					},
					癸: {
						lu: "子",
						ren: "亥"
					}
				},
				kuList: ["丑", "辰", "未", "戌"]
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				var panci = '';
				let type = this.geju.type;
				let year = this.geju.year;
				let month = this.geju.month;
				let day = this.geju.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.geju.time];
				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}

				//日主旺衰打分：得令+得地+得势
				let hasLing = false,
					hasDi = false,
					hasShi = false;
				const rigWx = bazi.getDayWuXing()[0];
				const yueZhi = bazi.getMonthZhi();
				// 1. 得令 +5 
				if (this.wangYue[rigWx].includes(yueZhi)) {
					hasLing = true;
					panci += '1. 得令，日主临月秉令，当令得时，月令本气归我，气场专旺。 <br> ';
				} else if (this.xiangYue[rigWx].includes(yueZhi)) {
					panci += '1. 相令，日主相令得生，月令有源来生身，扶身有气，根基不孤。 <br> ';
				} else {
					panci += '1. 失令，日主月令休囚，既无秉令又无生扶，克泄交加，气场无依。 <br> ';
				}
				// 2. 得地 日主五行在地支藏干中  本气强根，中气中根  余气弱根  无根失地
				//console.log(rigWx);日主五行
				const cangwxY = String(bazi.getYearHideGan()).split(',').map(item => {
					return this.getWx[item.trim()] || '';
				});
				const cangwxM = String(bazi.getMonthHideGan()).split(',').map(item => {
					return this.getWx[item.trim()] || '';
				});
				const cangwxD = String(bazi.getDayHideGan()).split(',').map(item => {
					return this.getWx[item.trim()] || '';
				});
				const cangwxT = String(bazi.getTimeHideGan()).split(',').map(item => {
					return this.getWx[item.trim()] || '';
				});
				const benqi = [cangwxY[0], cangwxM[0], cangwxD[0], cangwxT[0]];
				const zhongqi = [cangwxY[1] || '', cangwxM[1] || '', cangwxD[1] || '', cangwxT[1] || ''];
				const yuqi = [cangwxY[2] || '', cangwxM[2] || '', cangwxD[2] || '', cangwxT[2] || ''];
				const benqiCount = benqi.filter(z => rigWx.includes(z)).length;
				const zhongqiCount = zhongqi.filter(z => z && rigWx.includes(z)).length;
				const yuqiCount = yuqi.filter(z => z && rigWx.includes(z)).length;
				if (benqiCount >= 2) {
					hasDi = true;
					panci += '2. 得地，日主地支双根藏禄，本气通根厚重，根深蒂固，根基极稳身气充盈。 <br> ';
				} else if (benqiCount == 1 && (zhongqiCount >= 1 || yuqiCount >= 1)) {
					hasDi = true;
					panci += '2. 得地，日主有本气强根为基，又得中气余气相辅，主根有扶，得地有情。 <br> ';
				} else if (benqiCount == 1 || zhongqiCount >= 3 || yuqiCount >= 3) {
					hasDi = true;
					panci += '2. 得地，日主独得本气禄根一尊，无杂气相辅，孤根自立，得地不杂。 <br> ';
				} else if (zhongqiCount > 0) {
					hasDi = true;
					panci += '2. 得地，日主无本气强根，仅得地支中气藏干微扶，有根偏弱，底气不足。 <br> ';
				} else if (yuqiCount > 0) {
					hasDi = true;
					panci += '2. 弱得地，日主唯余气墓库藏微根，气散力浅，虽有根气难以为凭。 <br> ';
				} else {
					panci += '2. 日主四柱地支全无通根藏气，天干虚浮无依，失地无根根基单薄。 <br> ';
				}
				this.$store.commit('setGen',hasDi);

				// 3. 得势 我方（生扶党 = 得势势力）比肩、劫财、正印、偏印，敌方（克泄耗 = 耗势）正官、七杀、食神、伤官、正财、偏财
				let countWo = 0;
				let countDi = 0;
				const allTianGan = [bazi.getYearShiShenGan(), bazi.getMonthShiShenGan(), '比肩', bazi.getTimeShiShenGan()];
				allTianGan.forEach(item => {
					if (["比肩", "劫财", "正印", "偏印"].includes(item)) {
						countWo += 1;
					} else {
						countDi += 1;
					}
				})
				const allCangGan = [...bazi.getYearShiShenZhi(), ...bazi.getMonthShiShenZhi(), ...bazi.getDayShiShenZhi(), ...bazi.getTimeShiShenZhi()];
				allCangGan.forEach(item => {
					if (["比肩", "劫财", "正印", "偏印"].includes(item)) {
						countWo += 0.5;
					} else {
						countDi += 0.5;
					}
				})
				//console.log(countWo+'/'+countDi)
				if (countWo >= countDi + 1.5) {
					panci += '3. 得势，天干印比成群，党众助扶有力，同气连枝格局得势，气势恢弘身主强健。 <br> ';
					hasShi = true;
				} else if (countWo > countDi) {
					panci += '3. 得势，天干略有印比生扶，有同党相助，虽非党众成群，亦有帮扶身气不弱。 <br> ';
					hasShi = true;
				} else if (countWo == countDi) {
					panci += '3. 平势，天干生扶克泄力量相当，党势均分无偏盛偏衰，气机中和势均力敌。 <br> ';
				} else {
					panci += '3. 失势，天干无印比帮扶(虽有被克泄耗)，克泄耗交加，孤立无党势单力薄，身气衰弱无依托。 <br> ';
				}
				let shen = '';
				let yongShen = '';
				let jiShen = '';
				let shenLv = 3;//3强2中1弱
				if (hasLing && hasDi && hasShi) {
					shen = "秉月令提纲得时，地支本气中通根得地，天干印比成党得势，三美俱全，日主气厚身强，可任大财大官。";
					yongShen = "用神：喜官杀制衡、食伤泄秀、财星耗身，以克、泄、耗为用，疏导日主旺气，格局方能平衡有情。";
					jiShen = "忌神：忌印星生身、比劫助身，若再逢生扶，则旺气无制，孤旺无依，反为不美。";
					shenLv = 3;
				} else if (hasLing && hasDi && !hasShi) {
					shen = "月令秉令当权，地支通根有基，虽天干无党众帮扶，提纲得令带根，二势相扶，作身偏旺定论。";
					yongShen = "用神：喜官杀制衡、食伤泄秀、财星耗身，以克、泄、耗为用，疏导日主旺气，格局方能平衡有情。";
					jiShen = "忌神：忌印星生身、比劫助身，若再逢生扶，则旺气无制，孤旺无依，反为不美。";
					shenLv = 3;
				} else if (hasLing && !hasDi && hasShi) {
					shen = "月令提纲得令，天干印比成群助身，虽地支无本气中气根基，令势两相依托，仍归身偏旺之格。";
					yongShen = "用神：喜官杀制衡、食伤泄秀、财星耗身，以克、泄、耗为用，疏导日主旺气，格局方能平衡有情。";
					jiShen = "忌神：忌印星生身、比劫助身，若再逢生扶，则旺气无制，孤旺无依，反为不美。";
					shenLv = 3;
				} else if (hasLing && !hasDi && !hasShi) {
					shen = "仅得月令提纲一气之旺，地支无根、天干无扶，孤令无依，生扶克泄相停，格局气机中和。";
					yongShen = "用神：五行气机均衡，不偏不倚，宜顺势扶抑、平和取用，无需强补强克，顺局则吉。";
					jiShen = "忌神：忌某一行过旺过衰、偏执一方，打破原有中和之气，便生波折缺憾。";
					shenLv = 2;
				} else if (!hasLing && hasDi && hasShi) {
					shen = "月令休囚失令，幸赖地支通根得地，天干印比党众相扶，三项占二，根势有情，依旧作身偏旺推。";
					yongShen = "用神：喜官杀制衡、食伤泄秀、财星耗身，以克、泄、耗为用，疏导日主旺气，格局方能平衡有情。";
					jiShen = "忌神：忌印星生身、比劫助身，若再逢生扶，则旺气无制，孤旺无依，反为不美。";
					shenLv = 3;
				} else if (!hasLing && hasDi && !hasShi) {
					shen = "不得月令旺气，唯凭地支通根安身，天干无印比助力，有根无党，不旺不衰，格局定为中和。";
					yongShen = "用神：五行气机均衡，不偏不倚，宜顺势扶抑、平和取用，无需强补强克，顺局则吉。";
					jiShen = "忌神：忌某一行过旺过衰、偏执一方，打破原有中和之气，便生波折缺憾。";
					shenLv = 2;
				} else if (!hasLing && !hasDi && hasShi) {
					shen = "月令休囚、地支失地无根，只靠天干印比帮扶，虚浮无根基，有助无根，身气平平归入中和。";
					yongShen = "用神：五行气机均衡，不偏不倚，宜顺势扶抑、平和取用，无需强补强克，顺局则吉。";
					jiShen = "忌神：忌某一行过旺过衰、偏执一方，打破原有中和之气，便生波折缺憾。";
					shenLv = 2;
				} else {
					shen = "月令休囚无气，地支通根全无，天干又无党众生扶，克泄交加三失齐备，日主虚浮无根，身弱至极。";
					yongShen = "用神：喜印星生身、比劫帮扶，以生、扶为用，补日主根基、助自身元气，方可担财担官。";
					jiShen = "忌神：忌官杀克身、食伤泄气、财星耗身，再遇克泄耗，则身气愈虚，不堪负荷。";
					shenLv = 1;
				}
				//console.log(shenLv)
				this.$store.commit('shenLvData',shenLv);
				//4. 取格局（月令提纲取格）有官莫寻格局，有杀先论杀，无杀方论用。
				//透干定义：本 / 中 / 余气，出现在 年干、月干、时干 任意一个天干上

				let touGan = '';
				let benQi = bazi.getMonthShiShenZhi()[0];
				let zhongQi = bazi.getMonthShiShenZhi()[1];
				let yuQi = bazi.getMonthShiShenZhi()[2];
				const touGanList = [bazi.getYearShiShenGan(), bazi.getMonthShiShenGan(), bazi.getTimeShiShenGan()];
				let gejuName = '';

				// 1. 先判 建禄 / 羊刃 最高优先级
				const p = this.luRen[bazi.getDayGan()];
				if (yueZhi == p.lu) {
					gejuName = '建禄'
				} else if (yueZhi == p.ren) {
					gejuName = '羊刃'
				} else {
					if (touGanList.includes(benQi)) {
						touGan = benQi;
					} else if (zhongQi && touGanList.includes(zhongQi)) {
						touGan = zhongQi;
					} else if (yuQi && touGanList.includes(yuQi)) {
						touGan = yuQi;
					} else {
						touGan = benQi;
					}
					if (this.kuList.includes(yueZhi)) {
						gejuName = touGan + "格(杂气)";
					} else {
						gejuName = touGan + "格";
					}
				}

				//5. 自动取用神 忌神


				this.panci = panci;
				this.shen = '<p id="zong">综上所述：' + shen + '</p> <p id="geju">' + gejuName + ' <br> '+yongShen + ' <br> '+jiShen+'</p> ';



			},
		},
		watch: {
			geju(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.panci{
		line-height: 30px;
		padding-bottom: 10px;
	}
	.shen{
		line-height: 30px;
	}
</style>
<style>
	#zong{
		color: #CC2535;
		padding-bottom: 10px;
	}
	#geju{
		background-color: #f3f5f7;
		padding: 20px;
		box-sizing: border-box;
		border-radius: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/page/geju.vue